import { Theme as e } from "./theme.js";
const s = {
  "slate-v1": new e("slate-v1"),
  "slate-v4": new e("slate-v4")
};
export {
  s as THEMES
};
//# sourceMappingURL=theme-list.js.map
